'use client'

import {useIsomorphicLayoutEffect} from '@local/hooks'
import {usePathname} from 'next/navigation'
import {useCallback} from 'react'

export const FocusReset = () => {
	const pathname = usePathname()

	const handleRouteChange = useCallback(() => {
		const resetFocusItem = (
			document.querySelector('[data-focus]') ||
			document.getElementById('main-content') ||
			document.getElementsByTagName('h1')[0] ||
			document.getElementsByTagName('main')[0] ||
			document.body
		) as HTMLElement

		if (resetFocusItem) {
			resetFocusItem.setAttribute('tabindex', '-1')
			resetFocusItem.style.outline = 'none'
			resetFocusItem.focus()

			return () => {
				resetFocusItem.removeAttribute('tabindex')
				resetFocusItem.style.removeProperty('outline')
			}
		}
	}, [])

	useIsomorphicLayoutEffect(handleRouteChange, [pathname])

	return <></>
}
